import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=ba663564&"
import script from "./Scheme.vue?vue&type=script&lang=js&"
export * from "./Scheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports